import { InviteLink } from '@weblite/ts-action/hall'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { RemoveIcon } from '$common/icons/remove'
import { t } from '$i18n'
import { deleteInviteLinks } from '$logic/hall'

interface Props {
  link: InviteLink
  isOpen: boolean
}

export function RevokedLinkMenu({ link, isOpen }: Props) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('menu.inviteLink.remove')}
        onClick={async () => {
          await deleteInviteLinks(link.roomId, [link.link])
          await closeCurrentModal()
        }}
        error
      >
        <RemoveIcon sx={{ color: 'error.main' }} />
      </PopupMenuItem>
    </PopupMenuList>
  )
}
